import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { validateQty } from "@components/config/helpers";

const ProductInputFooter = (props) => {

    const {
        page,
        handleQtyChange,
        addToCart,
        qty = 1,
        product,
        source,
        padProduct,
        sectionID,
        type,
        handleExtra
    } = props;
    
    const add = () => {
        handleExtra(product, qty[product.product_id]);
        addToCart(product.product_id, product.product_slug, qty[product.product_id], product.bow_color_option, product.pad_color_option, product.color, source, sectionID)
    }
    
    const handleChange = (e) => {
        if(e.target.value > 999){
            e.target.value = 999;
        }

        if(!validateQty(e.target.value)){
            e.target.value = 1;
        }
    }

    return (
        <>
        {/* <Grid className="p-1" item xs={6} sm={6} md={6} lg={6}> */}
        
        <Box 
            className="mb-2 d-flex w-100"
            sx={{
                mt: {
                    xl: 0,
                    lg: 1,
                    xs: 0,
                }
            }}
        >
                    <TextField
                        className="mr-0 pr-2"
                    
                        sx={{
                            '& .MuiInputBase-input' : {
                                padding: '7px'
                            },
                            width: {
                                xs: '100%',
                                md: '-webkit-fill-available',
                                lg: 'inherit'
                            }
                        }}
                        label="Quantity"
                        defaultValue={1}
                        onBlur={(e) => handleQtyChange(e, product.product_id)} //doesnt have input delay
                        // onChange={(e) => handleQtyChange(e, product.product_id)}
                        onChange={handleChange}
                        InputProps={{ inputProps: { min: 1, max: 99, className: 'qty-input'} }}
                        // defaultValue="1"
                        type="number"
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <Button
                        size="small"
                        sx={{
                            width: {
                                // md: '-webkit-fill-available',
                            }
                        }}
                        className="cart-add"
                        color="secondary"
                        onClick={add} 
                        // loadingPosition="start"
                        // startIcon={<AddShoppingCartIcon />}
                        variant="contained"
                        >
                        Quote
                    </Button>
            {/* </Grid> */}
            {/* <Grid className="p-1" item xs={6} sm={6} md={6} lg={6}> */}


            {/* </Grid> */}

        </Box>
    
        
        </>

    )
}

export default ProductInputFooter